import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import useAuthStore from "store/authStore";
import { fetchConfig } from "utils";

const useIsInWishlist = (bookId) => {
	const { accessToken } = useTokenStore();
	const isLoggedIn = useAuthStore((state) => state.loggedIn);

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const res = await instance.get(`books/${bookId}/in-wishlist`);
		return res.data?.data?.in_wishlist ?? false;
	};

	return useQuery(["wishlist", "in-wishlist", bookId], () => fetch(), {
		...fetchConfig,
		enabled: !!bookId && !!isLoggedIn,
	});
};

export default useIsInWishlist;
